import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';
import { List } from '../../common/components';
import { NavLink } from 'react-router-dom';
import { stripWPPath } from '../../../utils/stripWPPath';

const StyledList = styled(List).attrs({ Container: 'ul' })`
  width: 100%;
  text-align: center;
  font-size: 3.5rem !important;
  ${styles.media.phone`
    font-size: 2rem !important;
  `} font-family: 'ApercuBlack';
  line-height: 1.8em !important;
  margin-bottom: 0 !important;

  li {
    padding: 0 !important;
    &:last-of-type {
      margin-bottom: 0 !important;
    }
    &:before {
      content: unset !important;
    }

    a {
      color: ${styles.color.ORANGE};
      transition-property: color;
      transition-duration: 0.35s;
      transition-timing-function: ${styles.easing.inOutQuad};

      .current-input-mouse &:hover,
      .current-input-touch &:active {
        color: ${styles.color.SLATE};
      }
    }
  }
`;

const LinkList = props => {
  const { items } = props;

  const renderItem = (item, index) => {
    const url = stripWPPath(item.href);
    const isExternal = url === item.href && url.indexOf('://') > -1;
    return (
      <li key={index}>
        {!isExternal ? (
          <NavLink to={item.href}>{item.label}</NavLink>
        ) : (
          <a href={item.href} target="_blank">
            {item.label}
          </a>
        )}
      </li>
    );
  };

  return <StyledList items={items} renderItem={renderItem} />;
};

LinkList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default LinkList;



// WEBPACK FOOTER //
// ./src/modules/pages/components/LinkList.js